export default "__VITE_ASSET__BKQcxJs4__"